const PP2 = [
    {
        "index": 1,
        "content": "こんにちは。お元気でしたか？",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 2,
        "content": "はい、元気にしていました。あなたはどうですか？",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 3,
        "content": "私も元気にしていました。休みの日には趣味の写真を楽しんでいます。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 4,
        "content": "写真ですか、いいですね。私は海の近くに住んでいるので、よく散歩をしています。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 5,
        "content": "海の近くにお住まいなんですね。綺麗でしょうね。私は山のそばに住んでいます。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 6,
        "content": "そうなんですね。山も好きなのですが、沖縄に以前住んでいてどうしても海の近くに住みたくて。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 7,
        "content": "生まれ育った場所に似た場所はなんだか心が落ち着きますよね。私も青森出身なのでお気持ちわかります。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 8,
        "content": "そうですよね。しかも私は怒りっぽいので、気持ちを静めるにも海はいいんですよ",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 9,
        "content": "自然は心を落ち着かせてくれますよね。私も今度海辺の写真を撮りに行きたいです。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 10,
        "content": "はい、海もさまざまな表情を見せますのでとても良いと思います。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 11,
        "content": "またおすすめの場所があったらぜひ教えてくださいね。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 12,
        "content": "はい。私はダンスが得意なんですが、あなたはどうですか？",
        "person": "A",
        "role": "scain",
    },
    {
        "index": 13,
        "content": "私はダンスにはなかなか縁がなくて、めっきりです。ダンスを見るのは好きなのですが。",
        "person": "user",
        "role": "scain",
    },
    {
        "index": 14,
        "content": "そうなんですね。でも、見るのがお好きなら今度ご披露します",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 15,
        "content": "ぜひ、よろしくお願いします。Bさんも見に行きませんか？",
        "person": "user",
        "role": "core",
    },
    {
        "index": 16,
        "content": "ぜひ行ってみたいです。海は本当にリフレッシュできそうですね。",
        "person": "B",
        "role": "normal",
    },
];

export default PP2;